import { render, staticRenderFns } from "./7DocumentUploads.vue?vue&type=template&id=5ac18f46&scoped=true"
import script from "./7DocumentUploads.vue?vue&type=script&lang=js"
export * from "./7DocumentUploads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac18f46",
  null
  
)

export default component.exports